module.exports = [
  {
    cardId: 1,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "CET Registration",
    linkText: "Register Now",
    openModal: true,
    moreLinks: [
    {
      title: "Technical Education",
      types: [
        {
          type: "UG",
          linkUrls: [
            {
              title: "MHT-CET 2025",
              linkUrl: "https://stagingmhtcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mht_cet",
            },
            {
              title: "MHT-CET 2026",
              linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=124&coursename=MHT-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mht_cet",
            },
            {
              title: "UAT-MHT-CET 2026",
              linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=124&coursename=MHT-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mht_cet",
            },
            {
              title: "MAH-B.HMCT/M.HMCT (Integrated) CET-2025",
              linkUrl: "http://stagingbhmctcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_bhmct_cet",
            },
            {
              title: "MAH-B.Design-CET-2025",
              linkUrl: "https://stagingbdesigncet2023reglive.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_bdesign_cet",
            },
            {
              title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
              linkUrl: "https://stagingbbabcacet24.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_bbabca_cet",
            },
            /* {
              title: "MAH-M.Planning Integrated CET-2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_mplanning_cet",
            },
            {
              title: "MAH-M.HMCT Integrated CET-2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_mhmctintegrated_cet",
            }, */
            {
              title: "MAH - B.BCA/BBA/BMS/BBM (Additional Attempt) CET 2025",
              linkUrl: "https://stagingbbabcacet24.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_bbabca_reattempt_cet",
            },
            /* {
            title: "MHT-CET-(PCM,PCB & PCMB)",
            linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=124&coursename=MHT-CET-(PCM,PCB & PCMB)",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mht_cet",
            }, */
          ],
        },
        {
          type: "PG",
          linkUrls: [
            {
              title: "MAH-MBA/MMS-CET 2026",
              linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=125&coursename=MAH-MBA/MMS-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mba_mms_cet",
            },
            {
              title: "UAT-MAH-MBA/MMS-CET 2026",
              linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=125&coursename=MAH-MBA/MMS-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mba_mms_cet",
            },
            /* {
              title: "MAH-M.Arch-CET 2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_march_cet",
            }, */
            {
              title: "MAH-M.HMCT-CET 2025",
              linkUrl: "http://stagingmhmctcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mhmct_cet",
            },
            {
              title: "MAH-MCA-CET 2026",
              linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=130&coursename=MAH-MCA-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mca_cet",
            },
            {
              title: "UAT-MAH-MCA-CET 2026",
              linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=130&coursename=MAH-MCA-CET 2026",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mca_cet",
            },
            /* {
              title: "MAH-MBA/MMS",
              linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=125&coursename=MAH-MBA/MMS",
              linkText: "Register Now",
              alternativeText: "",
              enum: "mah_mba_mms_cet",
            }, */
          ],
        },
      ],
    },
  {
    title: "Agriculture Education",
    types: [
      {
        type: "",
        linkUrls: [
          {
            title: "MHT-CET-2025",
            linkUrl: "https://stagingmhtcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mht_cet",
          },
        ],
      },
    ],
  },
  {
    title: "Higher Education",
    types: [
      {
        type: "UG",
        linkUrls: [
          {
            title: "MAH-LLB (5-Years) CET-2025",
            linkUrl: "https://stagingllb5cet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_llb_5years_cet",
          },
          {
            title: "MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2026",
            linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=132&coursename=MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2026",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_bed_general_bed_elct_cet",
          },
          {
            title: "UAT-MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2026",
            linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=132&coursename=MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2026",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_bed_general_bed_elct_cet",
          },
          {
            title: "MAH-B.P.Ed.-CET-2025",
            linkUrl: "https://stagingbpedcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_bped_cet",
          },
          {
            title: "MAH-L.L.B.3 Yrs. CET-2026",
            linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=131&coursename=MAH-LLB (3-Years)-CET-2026",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_llb_3years_cet",
          },
          {
            title: "UAT-MAH-L.L.B.3 Yrs. CET-2026",
            linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=131&coursename=MAH-LLB (3-Years)-CET-2026",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_llb_3years_cet",
          },
          {
            title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
            linkUrl: "https://stagingbabscbedcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_ba_bsc_bed_4years",
          },
        ],
      },
      {
        type: "PG",
        linkUrls: [
          {
            title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
            linkUrl: "https://stagingbedmedcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_bed_med_3years_cet",
          },
          {
            title: "M.Ed.- CET 2025",
            linkUrl: "https://stagingmedcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_med_cet",
          },
          {
            title: "M.P.Ed. - CET 2025",
            linkUrl: "https://stagingmpedcet22.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_mped_cet",
          },
        ],
      },
    ],
  },
  {
    title: "Medical Education",
    types: [
      {
        type: "UG",
        linkUrls: [
          {
            title: "MH-Nursing CET 2025 (For B.Sc Nursing, ANM & GNM courses)",
            linkUrl: "https://stagingnursingcetreg23.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "bsc_nursing_cet",
          },
          {
            title: "MH-DPN/PHN-CET-2025",
            linkUrl: "https://stagingdpnphncetreg24.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_dpnphn_cet",
          },
        ],
      },
      {
        type: "PG",
        linkUrls: [
          {
            title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
            linkUrl: "https://mhcet-reg-dev.hubblehox.ai/mhcet/registrations?courseid=23&coursename=MAH-PGP-CET/PGO-CET/M.Sc(A&SLP)-CET/M.Sc(P&O)-CET-2025",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_pgp_pgo_msc",
          },
          {
            title: "UAT - MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
            linkUrl: "https://mhcet-reg-uat1.hubblehox.ai/mhcet/registrations?courseid=23&coursename=MAH-PGP-CET/PGO-CET/M.Sc(A&SLP)-CET/M.Sc(P&O)-CET-2025",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_pgp_pgo_msc",
          },
        ],
      },
    ],
  },
  {
    title: "Fine Art",
    types: [
      {
        type: "",
        linkUrls: [
          {
            title: "MAH-AAC CET",
            linkUrl: "https://stagingaaccet2022.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "Register Now",
            alternativeText: "",
            enum: "mah_aac_cet",
          },
        ],
      },
    ],
  },
],
  },
  {
    cardId: 2,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/edit_profile.svg`,
    title: "Profile",
    linkText: "Edit Profile",
    editModal: true,
  },
  {
    cardId: 3,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "Centralized Admission Process (CAP) Registration",
    linkText: "Register Now",
    capModal: true,
    moreLinks: [
      /* {
        title: "Technical Education",
        types: [
          { 
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Engineering",
                linkUrl: "http://stagingfe2023.azurewebsites.net/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_be_cap",
              },
              {
                title: "Bachelor of Pharmacy",
                linkUrl: "http://stagingph23.azurewebsites.net/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bphar_cap",
              },
              {
                title: "Bachelor of Hotel Management & Catering Technology",
                linkUrl: "https://api.4pindia.com:3344/hmct/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bhmct_cap",
              },
              {
                title: "Bachelor of Architecture",
                linkUrl: "https://api.4pindia.com:3344/arch/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_barch_cap",
              },
              {
                title: "B. Designing",
                linkUrl: "http://stagingbdesign2023.azurewebsites.net/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bdesign_cap",
              },
              {
                title: "Direct Second Year Degree in Engineering",
                linkUrl: "https://admissioncet.4pindia.com/dse25_SSO/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_eng_cap",
              },
              {
                title: "Direct Second Year Degree in Engineering (Working Professionals)",
                linkUrl: "https://admissioncet.4pindia.com/dsewp25_SSO/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_eng_wp_cap",
              },
              {
                title: "Direct Second Year Degree in Pharmacy",
                linkUrl: "https://api.4pindia.com:3344/dsp/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_phar_cap",
              },
              {
                title: "Direct Second Year Degree in Hotel Management & Catering Technology",
                linkUrl: "https://api.4pindia.com:3344/cdhmct/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_hmct_cap",
              },
              {
                title: "B.Pharmacy (Practice)",
                linkUrl: "http://staggingbpharmapractise23.azurewebsites.net/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bphar_prac_cap",
              },
              {
                title: "BCA/MCA (Integrated)",
                linkUrl: "https://stagingbbabca2024.azurewebsites.net/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bca_mca_integrated_ug_cap",
              }
            ]
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "Master of Engineering",
                linkUrl: "http://stagingmemtech2023.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_me_cap",
              },
              {
                title: "Master of Engineering (Working Professionals)",
                linkUrl: "https://stagingmemtechprofessionals2024.azurewebsites.net/RegistrationModule/frmInstructionsBeforeRegistration",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_me_wp_pg_cap",
              },
              {
                title: "Master of Business Administration / Master of Management Studies",
                linkUrl: "https://admissioncet.4pindia.com/cetmba25_SSO/mba25/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mba_mms_cap",
              },
              {
                title: "Master of Business Administration (Working Professionals)",
                linkUrl: "https://admissioncet.4pindia.com/cetmbawp25_SSO/mbawp25/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mba_wp_cap",
              },
              {
                title: "Master of Business Administration (Lateral Entry)",
                linkUrl: "https://api.4pindia.com:3344/mbale/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mba_le_cap",
              },
              {
                title: "Master of Computer Application",
                linkUrl: "https://api.4pindia.com:3344/mca/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mca_cap",
              },
              {
                title: "Master of Computer Application (Working Professionals)",
                linkUrl: "https://api.4pindia.com:3344/mcawp/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mca_wp_cap",
              },
              {
                title: "Master of Computer Application (Lateral Entry)",
                linkUrl: "https://api.4pindia.com:3344/mcale/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mca_le_cap",
              },
              {
                title: "Masters of Hotel Management & Catering Technology",
                linkUrl: "https://api.4pindia.com:3344/mhmct/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mhmct_cap",
              },
              {
                title: "Master of Architecture",
                linkUrl: "https://api.4pindia.com:3344/march/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_march_cap",
              },
              {
                title: "Master of Pharmacy",
                linkUrl: "https://api.4pindia.com:3344/mpharm/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mphar_cap",
              },
            ]
          }
        ]
      },
      {
        title: "Agriculture",
        types: [
          {
            type: "",
            linkUrls: [
              {
                title: "Bachelor of Agriculture",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "ag_common_ug_cap",
              },
              {
                title: "Direct Second Year of Bachelor of Science (Agriculture)",
                linkUrl:"https://agripug.epariksha.net/ApplicationFormLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "ag_sy_bsc_ug_cap",
              },
            ]
          }
        ]
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Education, Master’s in Education (Integrated)",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingbedmed25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bed_med_cap",
              },
              {
                title: "Bachelor of Law 5 Years (Integrated)",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingllb525/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_llb_5years_cap",
              },
              {
                title: "Bachelor of Law 3 Years",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingllb325/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_llb_3years_cap",
              },
              {
                title: "Bachelor of Education",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingbed25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bed_cap",
              },
              {
                title: "Bachelor of Physical Education",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingbped25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bped_cap",
              },
              {
                title: "Bachelor of Arts/Bachelor of Science - Bachelor of Education. (Integrated)",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingbabscbed25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_ba_bsc_bed_cap",
              }
            ]
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "Master of Education",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingmed25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_med_cap",
              },
              {
                title: "Master of Physical Education",
                linkUrl: "https://c20demoweb1.saas.talismaonline.com/stagingmped25/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_mped_cap",
              },
            ]
          }
        ]
      },
      {
        title: "Medical and Ayush Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Medical and Ayush Education",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_ug_cap",
              },
              {
                title: "Bachelor of Science in Nursing",
                linkUrl:"https://uat.statecetcell.in/NURSING-2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_bsn_cap",
              },
              {
                title: "Bachelor of Ayurveda Medicine All India",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_ug_cap_aiq",
              },
            ]
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "PGP/ PGO/ M.Sc (Audiology)/ M.Sc (SLP)/ M.Sc (P & O)",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_pg_masters_cap",
              },
              {
                title: "Postgraduation in Dental (MDS)",
                linkUrl:"https://uat.statecetcell.in/NEET-PGD-2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_mds_cap",
              },
              {
                title: "Postgraduation in Medicine (MD / MS)",
                linkUrl:"https://uat.statecetcell.in/NEET-PGM-2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_pgm_cap",
              },
              {
                title: "Postgraduation in Ayurveda (MD / MS) - STATE",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_pg_cap",
              },
              {
                title: "Postgraduation in Ayurveda (MD / MS) - All INDIA",
                linkUrl:"",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_common_pg_cap_aiq",
              },
            ]
          }
        ]
      },
      {
        title: "Fine Art Education",
        types: [
          {
            type: "",
            linkUrls: [
              {
                title: "Bachelor of Fine Art",
                linkUrl:"https://cetcell.in/FINEART2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "fae_common_ug_cap",
              },
            ]
          }
        ]
      }, */
    ]
  },
  {
    cardId: 4,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "Mock Test – CET Appearing",
    linkText: "Register Now",
    linkUrl: "https://stagingmocktest26-jioindiawest-01.azurewebsites.net/RegistrationModule/frmRegistrationDetails",
  },
  {
    cardId: 11,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "Mock Test – CET Non-Appearing",
    linkText: "Register Now",
    linkUrl: "https://stagingmocktest26-jioindiawest-01.azurewebsites.net/RegistrationModule/frmRegistrationDetails",
  },
  {
    cardId: 12,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "Psychometric Test – CET Appearing",
    linkText: "Register Now",
    linkUrl: "https://stagingmocktest26-jioindiawest-01.azurewebsites.net/RegistrationModule/frmRegistrationDetails",
  },
  {
    cardId: 13,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "Psychometric Test – CET Non-Appearing",
    linkText: "Register Now",
    linkUrl: "https://stagingmocktest26-jioindiawest-01.azurewebsites.net/RegistrationModule/frmRegistrationDetails",
  },
  {
    cardId: 5,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/support-ticket.svg`,
    title: "Help Desk",
    linkText: "Create or Track Issues",
    linkUrl: "https://helpdesk-2026.maharashtracet.org/login.php?do=ext&bk=oauth2.user.p1i4",
  },
  {
    cardId: 6,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/hall_ticket.svg`,
    title: "Hall Ticket or Admit Card",
    linkText: "Get Hall Ticket",
    openModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/M.HMCT (Integrated) CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bhmct_cet",
              },
               {
                 title: "MAH-B.Design-CET-2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bdesign_cet",
               },
               {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mhmctintegrated_cet",
              },
               {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                 title: "MAH-MBA/MMS-CET 2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_mba_mms_cet",
              },
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mhmct_cet",
              },
              {
                 title: "MAH-MCA-CET 2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_mca_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
              // {
              //   title: "MHT-CET-2025",
              //   linkUrl: "",
              //   linkText: "Get Hall Ticket",
              //   alternativeText: "",
              //   enum: "mht_cet",
              // },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_llb_5years_cet",
               }, 
               {
                 title: "MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bed_general_bed_elct_cet",
               },
               {
                 title: "MAH-B.P.Ed.-CET-2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bped_cet",
               },
               {
                 title: "MAH-L.L.B.3 Yrs. CET-2025",
                 linkUrl: "",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_llb_3years_cet",
               },
              {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl:"",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_ba_bsc_bed_4years",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MH-Nursing CET 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_dpnphn_cet",
              },
              {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              // {
              //   title:
              //     "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
              //   linkUrl: "",
              //   linkText: "Get Hall Ticket",
              //   alternativeText: "",
              //   enum: "mah_pgp_pgo_msc",
              // },
            ],
          },
        ],
      },
      {
        title: "Fine Art",
        types: [
          {
            type: "",
            linkUrls: [
              {
                title: "MAH-AAC CET",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    cardId: 7,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/objection_tracking.svg`,
    title: "Objection Tracker",
    linkText: "Track Here",
    openModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              /*{
                title: "MHT-CET (PCB) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },*/
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/M.HMCT (Integrated) CET-2025",
                linkUrl: "https://ot.mhexam.com/BHMCT-W4X9M7QP",
                linkText: "Raise an Objection",
                enum: "mah_bhmct_cet",
              },
              {
                title: "MAH-B.Design-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_bdesign_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
               {
                title: "MAH-MBA/MMS-CET 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mba_mms_cet",
              }, 
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "https://ot.mhexam.com/MHMCT-J4X7M9QP",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mhmct_cet",
              },
               {
                title: "MAH-MCA-CET 2025",
                linkUrl: "https://ot.mhexam.com/MCA-F3N7L9WX",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mca_cet",
              },
              {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mhmctintegrated_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_llb_5years_cet",
              },
              {
                title: "MAH-B.Ed (General & Special)",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.Ed ELCT-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bed_general_bed_elct_cet",
              }, 
              {
                title: "MAH-B.P.Ed.-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bped_cet",
              },
               {
                title: "MAH-L.L.B.3 Yrs. CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_llb_3years_cet",
              },
             {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_ba_bsc_bed_4years",
              }, 
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "https://ot.mhexam.com/BEd-MEd-V6Q3X9LP",
                linkText: "Raise an Objection",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "https://ot.mhexam.com/MED-K2W8Q7ML",
                linkText: "Raise an Objection",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "https://ot.mhexam.com/MPED-Q7X4M2LP/",
                linkText: "Raise an Objection",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MH-Nursing CET 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_dpnphn_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
        ],
      },
      {
        title: "Fine Arts",
        types: [
          {
            type: "",
            linkUrls: [
              /* {
                title: "MAH-AAC CET",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_aac_cet",
              }, */
              {
                title: "MAH-AAC CET",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
              /* {
                title: "MHT-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              }, */
            ],
          },
        ],
      },
    ],
  },
  {
    cardId: 8,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/score_card.svg`,
    title: "Score Card",
    linkText: "Get Score Card",
    openModal: true,
    linkUrl: "",
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             /* {
                title: "MHT-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              }, */
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/M.HMCT (Integrated) CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bhmct_cet",
              },
              {
                title: "MAH-B.Design-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bdesign_cet",
              },
              {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mhmctintegrated_cet",
              },
              {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-MBA/MMS-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mba_mms_cet",
              }, 
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mhmct_cet",
              },
              {
                title: "MAH-MCA-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mca_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_llb_5years_cet",
              },
              {
                title: "MAH-B.Ed. (General)",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.Ed & B.Ed ELCT",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.P.Ed.-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bped_cet",
              },
              {
                title: "MAH-L.L.B.3 Yrs. CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_llb_3years_cet",
              },
              {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_ba_bsc_bed_4years",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             {
                title: "MH-Nursing CET 2025 (For B.Sc Nursing, ANM & GNM courses)",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_dpnphn_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
             {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
        ],
      },
      {
        title: "Fine Arts",
        types: [
          {
            type: "",
            linkUrls: [
             {
                title: "MAH-AAC CET",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
             /* {
                title: "MHT-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              }, */
            ],
          },
        ],
      },
    ],
  }, 
  {
    cardId: 9,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "ARA",
    linkText: "Get Details",
    linkUrl: "https://qa-frontend-service-888264926698.asia-south1.run.app/araproject",
  },
  {
    cardId: 10,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/notification.svg`,
    title: "Notifications",
    linkText: "Get Details",
    linkUrl: "https://cetcell.mahacet.org/notices/",
  },
];
